import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/packing_by_pallet/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchContainer(packing_house_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/packing_by_pallet/${packing_house_id}/manage_package_group/fetch_container/${container_id}`
    );
  },

  fetchUnassignedPackageGroups(packing_house_id, container_id, package_group_id) {
    return RequesterV1.get(
      `packing_house/production/packing_by_pallet/${packing_house_id}/manage_package_group/fetch_unassigned_package_groups/${container_id}/${package_group_id ?? ''}`
    );
  },

  fetchPackageGroup(packing_house_id, container_id, package_group_id) {
    return RequesterV1.get(
      `packing_house/production/packing_by_pallet/${packing_house_id}/manage_package_group/${container_id}/${package_group_id}`
    );
  },

  update(packing_house_id, container_id, package_group_id, package_group) {
    return RequesterV1.post(
      `packing_house/production/packing_by_pallet/${packing_house_id}/manage_package_group/${container_id}/${package_group_id}`,
      { package_group }
    );
  },

  destroy(packing_house_id, container_id, package_group_id) {
    return RequesterV1.delete(
      `packing_house/production/packing_by_pallet/${packing_house_id}/manage_package_group/${container_id}/${package_group_id}`
    );
  },
};
